import { useState, useEffect, useCallback } from 'react'
import { HiddenTransactionsService } from '../services/hidden-transactions.service'
import { HiddenTransaction } from '../types/database'

export function useMarketHiddenTransactions(numericModelId: number | undefined) {
  // Org-wide hidden transaction rows in the sold table
  const [hiddenTransactions, setHiddenTransactions] = useState<HiddenTransaction[]>([])

  // Load org-wide hidden transactions for this model
  useEffect(() => {
    const loadHiddenTransactions = async () => {
      if (numericModelId) {
        try {
          const hidden = await HiddenTransactionsService.getByModelId(numericModelId)
          setHiddenTransactions(hidden)
        } catch (error) {
          // Error loading hidden transactions - silently ignore
        }
      }
    }
    loadHiddenTransactions()
  }, [numericModelId])

  // Handle hiding a transaction row (org-wide)
  const handleHideTransaction = useCallback(async (identifier: string) => {
    if (!numericModelId) return
    try {
      const hidden = await HiddenTransactionsService.hide(numericModelId, identifier)
      setHiddenTransactions(prev => [...prev, hidden])
    } catch (error) {
      console.error('Error hiding transaction:', error)
    }
  }, [numericModelId])

  // Handle unhiding a transaction row (org-wide)
  const handleUnhideTransaction = useCallback(async (identifier: string) => {
    if (!numericModelId) return
    try {
      await HiddenTransactionsService.unhide(numericModelId, identifier)
      setHiddenTransactions(prev => prev.filter(h => h.transaction_identifier !== identifier))
    } catch (error) {
      console.error('Error unhiding transaction:', error)
    }
  }, [numericModelId])

  return {
    hiddenTransactions,
    handleHideTransaction,
    handleUnhideTransaction,
  }
}

